export default __webpack_public_path__ + "static/media/img15.40cacf61.jpg";